// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1jncD","messages":"Chat_messages__oyH8V","dateDivider":"Chat_dateDivider__1AjvS"};